"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentsOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var moment = require("moment");
var DocumentsOutputWidget = exports.DocumentsOutputWidget = /** @class */ (function (_super) {
    __extends(DocumentsOutputWidget, _super);
    function DocumentsOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.OLD_MISSED_PAYMENT_PROCESS = "oldMissedPaymentProcess";
        _this.OLD_CAR_DOI_PDF_PATH = "/resources/documents/LV_Flow_Car/v1/LV_Flow_Car_DOI_v1.pdf";
        _this.NEW_CAR_DOI_PDF_PATH = "/resources/documents/LV_Flow_Car/v2/LV_Flow_Car_DOI_v2.pdf";
        _this.NEWEST_CAR_DOI_PDF_PATH = "/resources/documents/LV_Flow_Car/v3/LV_Flow_Car_DOI_v3.pdf";
        _this.OLD_RENTERS_DOI_PDF_PATH = "/resources/documents/LV_Flow_Renters/v1/LV_Flow_Renters_DOI_v1.pdf";
        _this.NEW_RENTERS_DOI_PDF_PATH = "/resources/documents/LV_Flow_Renters/v2/LV_Flow_Renters_DOI_v2.pdf";
        _this.OLD_DOCUMENT_DATE_2023 = moment.utc("2023-08-24", 'YYYY-MM-DD');
        _this.documents = _this.getSetting("documents", undefined);
        if (!_this.documents || _this.documents.length === 0) {
            throw Error("".concat(_this.props.question.type, " widget missing 'documents' setting"));
        }
        _this.isNewBusinessJourney = _this.getSetting("isNewBusinessJourney", false);
        _this.state = {
            documentPathToSizeMap: new Map(),
            isMobileScreenSize: window.innerWidth < 768,
            oldMissedPaymentProcess: null
        };
        window.addEventListener("resize", _this.resize.bind(_this));
        _this.trimFileExtension = _this.trimFileExtension.bind(_this);
        _this.removeDocument = _this.removeDocument.bind(_this);
        _this.processDocuments = _this.processDocuments.bind(_this);
        _this.setDocumentFileSize = _this.setDocumentFileSize.bind(_this);
        return _this;
    }
    DocumentsOutputWidget.prototype.render = function () {
        var _this = this;
        var documentsToRender = this.documents.map(function (document, i) { return (React.createElement("li", { key: i, className: "media" },
            React.createElement("img", { className: "mr-2 document-icon", alt: "document-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }),
            React.createElement("div", { className: "media-body" },
                document.title ?
                    (React.createElement("h5", null,
                        React.createElement("a", { className: "no-underline font-weight-light", href: document.path, download: document.filename ? document.filename : "document", id: document.filename ? _this.trimFileExtension(document.filename) : "document", "aria-label": "".concat(document.title) }, document.title),
                        React.createElement("p", { className: "d-mobile-none document-size" }, _this.state.documentPathToSizeMap.get(document.path)))) : "",
                document.description ? (React.createElement("p", null,
                    React.createElement("small", null, document.description))) : ""))); });
        return (React.createElement("div", { id: this.props.question.name, className: "documents-widget documents-output-widget ".concat(this.getSetting("cssClass", "")) },
            this.props.question.label ? (React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18" }, this.props.question.label)) : "",
            this.getSetting("helpText", undefined) ? (React.createElement("p", null, this.getSetting("helpText", ""))) : "",
            React.createElement("ul", { className: "list-unstyled documents-section" }, documentsToRender)));
    };
    DocumentsOutputWidget.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.isNewBusinessJourney) {
            this.customerPortalService.getPartyPropertyByPropertyKey(this.OLD_MISSED_PAYMENT_PROCESS).subscribe(function (property) {
                _this.setState({ oldMissedPaymentProcess: !(property == null || property.value == "false") }, _this.processDocuments);
            });
        }
        else {
            this.setDocumentFileSize();
        }
    };
    DocumentsOutputWidget.prototype.processDocuments = function () {
        var _a, _b;
        var originalLatestQuoteDate;
        if (this.props.interaction && this.props.interaction.factors && this.props.interaction.factors.originalQuoteDate) {
            var originalQuoteDateRaw = (_b = (_a = this.props.interaction.renewalDetails) === null || _a === void 0 ? void 0 : _a.periodStartDate) !== null && _b !== void 0 ? _b : this.props.interaction.factors.originalQuoteDate;
            originalLatestQuoteDate = moment.utc(originalQuoteDateRaw, moment.ISO_8601);
        }
        if (this.state.oldMissedPaymentProcess) {
            if (moment(this.props.interaction.uistate.cancelledPolicyEndDate).isBefore(moment())) {
                if (this.OLD_DOCUMENT_DATE_2023.isAfter(originalLatestQuoteDate)) {
                    this.removeDocument(this.NEWEST_CAR_DOI_PDF_PATH);
                }
                else {
                    this.removeDocument(this.NEW_CAR_DOI_PDF_PATH);
                    this.removeDocument(this.NEW_RENTERS_DOI_PDF_PATH);
                }
                this.removeDocument(this.OLD_CAR_DOI_PDF_PATH);
                this.removeDocument(this.OLD_RENTERS_DOI_PDF_PATH);
            }
            else {
                this.removeDocument(this.NEWEST_CAR_DOI_PDF_PATH);
                this.removeDocument(this.NEW_CAR_DOI_PDF_PATH);
                this.removeDocument(this.NEW_RENTERS_DOI_PDF_PATH);
            }
        }
        else {
            if (this.OLD_DOCUMENT_DATE_2023.isAfter(originalLatestQuoteDate)) {
                this.removeDocument(this.NEWEST_CAR_DOI_PDF_PATH);
            }
            else {
                this.removeDocument(this.NEW_CAR_DOI_PDF_PATH);
                this.removeDocument(this.NEW_RENTERS_DOI_PDF_PATH);
            }
            this.removeDocument(this.OLD_CAR_DOI_PDF_PATH);
            this.removeDocument(this.OLD_RENTERS_DOI_PDF_PATH);
        }
        this.setDocumentFileSize();
    };
    DocumentsOutputWidget.prototype.setDocumentFileSize = function () {
        var _this = this;
        this.documents.forEach(function (document) {
            _this.baseRequestService.getDocumentSize(document.path).subscribe(function (response) {
                _this.setState({
                    documentPathToSizeMap: _this.state.documentPathToSizeMap.set(document.path, _this.formatFileSize(response.xhr.getResponseHeader('content-length')))
                });
            });
        });
    };
    DocumentsOutputWidget.prototype.removeDocument = function (documentPath) {
        var itemIndex = this.documents.map(function (document) { return document.path; }).indexOf(documentPath);
        if (itemIndex >= 0) {
            this.documents.splice(itemIndex, 1);
        }
    };
    DocumentsOutputWidget.prototype.trimFileExtension = function (filename) {
        return filename.substring(0, filename.lastIndexOf('.'));
    };
    DocumentsOutputWidget.prototype.formatFileSize = function (byteSize) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (byteSize === 0) {
            return '';
        }
        var kilobyteSize = parseInt(String(Math.floor(Math.log(byteSize) / Math.log(1024))), 10);
        return Math.round(byteSize / Math.pow(1024, kilobyteSize)) + ' ' + sizes[kilobyteSize];
    };
    DocumentsOutputWidget.prototype.resize = function () {
        var currentIsMobile = (window.innerWidth < 768);
        if (currentIsMobile !== this.state.isMobileScreenSize) {
            this.setState({ isMobileScreenSize: currentIsMobile });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.BaseRequestService),
        __metadata("design:type", Object)
    ], DocumentsOutputWidget.prototype, "baseRequestService", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], DocumentsOutputWidget.prototype, "customerPortalService", void 0);
    return DocumentsOutputWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=DocumentsOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/DocumentsOutputWidget.js
// module id = 3632
// module chunks = 0